module.exports = __webpack_public_path__ + "img/20191115130847385.4e8246b1.jpg";